import { AddEditAccountGroup, AddEditColors, AddEditDaybook, AddEditHSNCode, AddEditItemGategory, AddEditItems, AddEditLabelClaims, AddEditMfgLic, AddEditPackingMaterialSize, AddEditPartyDetails, AddEditpartyWiseNetRateDetails, AddEditPMCategory, AddEditPMFormulaDetails, AddEditProductDetails, AddEditProductionStages, AddEditPunchSizeMaster, AddEditRMCategory, AddEditRMFormulaDetails, AddEditStates, AddEditStereo, AddEditStorageConditions, AddEditTestMaster, AddEditTransportCourier, AddQCMonoGram, DeleteAccountGroupById, DeleteCategoryById, DeleteColorById, DeleteDaybookById, DeleteHSNCodeById, DeleteItemById, DeleteLabelClaimById, DeleteMfgLicById, DeletePackingMaterialSizeById, DeletePartyDetailsById, DeletePartyWiseNetRateById, DeletePMCategoryById, DeletePMFurmulaById, DeleteProductDetailsById, DeleteProductionStageById, DeletePunchSizeById, DeleteQCMonogramById, DeleteRMCategoryById, DeleteRMFurmulaById, DeleteStateById, DeleteStereoById, DeleteStorageConditionById, DeleteTestById, DeleteTransportCourierById, GetAllItems, GetAllParties, GetAllProductDetails, GetCompanyDetailsByGSTNumber, GetItemById, GetPartyDetailsById, GetPartyWiseNetRateDetailsByPartyId, GetPMFormulaByItemId, GetProductDetailById, GetQCMonogramByPMId, GetQCMonogramByProductId, GetQCMonogramByRMId, GetRMFormulaByProductId, UpdateQCMonoGram } from "../ApiEndPoints.js";
import { axiosGetMultiParams, axiosGetWithencryption, axiosPostWithencryption } from "../AxiosRequests.js";

export default class ItemMasterServices {

    async getAllItems(request) {
        return axiosGetWithencryption(GetAllItems, request);
    }
    async getItemById(request) {
        return axiosGetWithencryption(GetItemById, request);
    }

    async addEditItems(request) {
        return axiosPostWithencryption(AddEditItems, request)
    }
    async deleteItemById(request) {
        return axiosGetWithencryption(DeleteItemById, request)
    }

    async addEditItemGategory(request) {
        return axiosPostWithencryption(AddEditItemGategory, request)
    }
    async deleteCategoryById(request) {
        return axiosGetWithencryption(DeleteCategoryById, request)
    }

    async addEditHSNCode(request) {
        return axiosPostWithencryption(AddEditHSNCode, request)
    }
    async deleteHSNCodeById(request) {
        return axiosGetWithencryption(DeleteHSNCodeById, request)
    }

    async addEditRMCategory(request) {
        return axiosPostWithencryption(AddEditRMCategory, request)
    }
    async deleteRMCategoryById(request) {
        return axiosGetWithencryption(DeleteRMCategoryById, request)
    }

    async addEditPMCategory(request) {
        return axiosPostWithencryption(AddEditPMCategory, request)
    }
    async deletePMCategoryById(request) {
        return axiosGetWithencryption(DeletePMCategoryById, request)
    }

    async addEditPackingMaterialSize(request) {
        return axiosPostWithencryption(AddEditPackingMaterialSize, request)
    }
    async deletePackingMaterialSizeById(request) {
        return axiosGetWithencryption(DeletePackingMaterialSizeById, request)
    }

    async addEditStates(request) {
        return axiosPostWithencryption(AddEditStates, request)
    }
    async deleteStateById(request) {
        return axiosGetWithencryption(DeleteStateById, request)
    }

    async addEditStereo(request) {
        return axiosPostWithencryption(AddEditStereo, request)
    }
    async deleteStereoById(request) {
        return axiosGetWithencryption(DeleteStereoById, request)
    }

    async addEditLabelClaims(request) {
        return axiosPostWithencryption(AddEditLabelClaims, request)
    }
    async deleteLabelClaimById(request) {
        return axiosGetWithencryption(DeleteLabelClaimById, request)
    }

    async addEditStorageConditions(request) {
        return axiosPostWithencryption(AddEditStorageConditions, request)
    }
    async deleteStorageConditionById(request) {
        return axiosGetWithencryption(DeleteStorageConditionById, request)
    }

    async addEditColors(request) {
        return axiosPostWithencryption(AddEditColors, request)
    }
    async deleteColorById(request) {
        return axiosGetWithencryption(DeleteColorById, request)
    }

    async addEditMfgLic(request) {
        return axiosPostWithencryption(AddEditMfgLic, request)
    }
    async deleteMfgLicById(request) {
        return axiosGetWithencryption(DeleteMfgLicById, request)
    }

    async addEditProductionStages(request) {
        return axiosPostWithencryption(AddEditProductionStages, request)
    }
    async deleteProductionStageById(request) {
        return axiosGetWithencryption(DeleteProductionStageById, request)
    }

    async addEditPunchSizeMaster(request) {
        return axiosPostWithencryption(AddEditPunchSizeMaster, request)
    }
    async deletePunchSizeById(request) {
        return axiosGetWithencryption(DeletePunchSizeById, request)
    }

    async addEditAccountGroup(request) {
        return axiosPostWithencryption(AddEditAccountGroup, request)
    }
    async deleteAccountGroupById(request) {
        return axiosGetWithencryption(DeleteAccountGroupById, request)
    }

    async addEditTransportCourier(request) {
        return axiosPostWithencryption(AddEditTransportCourier, request)
    }
    async deleteTransportCourierById(request) {
        return axiosGetWithencryption(DeleteTransportCourierById, request)
    }

    async addEditDaybook(request) {
        return axiosPostWithencryption(AddEditDaybook, request)
    }
    async deleteDaybookById(request) {
        return axiosGetWithencryption(DeleteDaybookById, request)
    }

    // Party Master
    async getAllParties(request) {
        return axiosGetWithencryption(GetAllParties, request)
    }

    async getPartyDetailsById(request) {
        return axiosGetWithencryption(GetPartyDetailsById, request);
    }

    async addEditPartyDetails(request) {
        return axiosPostWithencryption(AddEditPartyDetails, request);
    }
    async deletePartyDetailsById(request) {
        return axiosGetWithencryption(DeletePartyDetailsById, request)
    }
    async getCompanyDetailsByGSTNumber(request) {
        return axiosGetWithencryption(GetCompanyDetailsByGSTNumber, request)
    }

    // Product Details Master
    async getAllProductDetails(request) {
        return axiosGetMultiParams(GetAllProductDetails, request)
    }

    async getProductDetailById(request) {
        return axiosGetWithencryption(GetProductDetailById, request);
    }

    async addEditProductDetails(request) {
        return axiosPostWithencryption(AddEditProductDetails, request);
    }
    async deleteProductDetailsById(request) {
        return axiosGetWithencryption(DeleteProductDetailsById, request)
    }

    // Party Wise NetRate Master
    async getPartyWiseNetRateDetailsByPartyId(request) {
        return axiosGetWithencryption(GetPartyWiseNetRateDetailsByPartyId, request);
    }
    async addEditpartyWiseNetRateDetails(request) {
        return axiosPostWithencryption(AddEditpartyWiseNetRateDetails, request);
    }
    async deletePartyWiseNetRateById(request) {
        return axiosGetWithencryption(DeletePartyWiseNetRateById, request);
    }

    // RM Formula Master
    async getRMFormulaByProductId(request) {
        return axiosGetWithencryption(GetRMFormulaByProductId, request);
    }
    async addEditRMFormulaDetails(request) {
        return axiosPostWithencryption(AddEditRMFormulaDetails, request);
    }
    async deleteRMFurmulaById(request) {
        return axiosGetWithencryption(DeleteRMFurmulaById, request);
    }

    // PM Formula Master
    async getPMFormulaByItemId(request) {
        return axiosGetWithencryption(GetPMFormulaByItemId, request);
    }
    async addEditPMFormulaDetails(request) {
        return axiosPostWithencryption(AddEditPMFormulaDetails, request);
    }
    async deletePMFurmulaById(request) {
        return axiosGetWithencryption(DeletePMFurmulaById, request);
    }

    // Test Master
    async addEditTestMaster(request) {
        return axiosPostWithencryption(AddEditTestMaster, request)
    }
    async deleteTestById(request) {
        return axiosGetWithencryption(DeleteTestById, request)
    }

    // QC Monogram Raw Material
    async addQCMonoGram(request) {
        return axiosPostWithencryption(AddQCMonoGram, request)
    }
    async updateQCMonoGram(request) {
        return axiosPostWithencryption(UpdateQCMonoGram, request)
    }
    async getQCMonogramByRMId(request) {
        return axiosGetWithencryption(GetQCMonogramByRMId, request)
    }
    async deleteQCMonogramById(request) {
        return axiosGetWithencryption(DeleteQCMonogramById, request)
    }

    // QC Monogram Packing Material
    async getQCMonogramByPMId(request) {
        return axiosGetWithencryption(GetQCMonogramByPMId, request)
    }

    // QC Monogram Product
    async getQCMonogramByProductId(request) {
        return axiosGetWithencryption(GetQCMonogramByProductId, request)
    }

}

